// removed by extract-text-webpack-plugin
module.exports = {"field":"_1IBWPztRH uLOZaVgRx _34tRQChci","label":"_3511-bz8w _19zTgKSdc y4wLu1mD3 xBrMYP3IH aMITqvrwV","description":"_1fPGF_LrO y4wLu1mD3 _9w0k5KDRg _4kMpFLaRi","base-input":"JmRuDZRyu y4wLu1mD3 vUrsJl1Yt _19QZFK_l1 _1NlI_spEh _1EdaqRqa1 _2OFXNnC9U","children":"_26a9Dek0M vUrsJl1Yt"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/setupform-form/field/field.css
 ** module id = 2162
 ** module chunks = 0
 **/